import { Dispatch, Action } from "redux";
import { AppThunk, UserActions, CloudFunctions, UserCredentials } from "../types";
import { cloudFunction } from "../utils/functions";
import { getStartPayloadOf, getSuccessPayloadOf, getFailurePayloadOf } from "../utils/redux";
import firebase from 'firebase/app';


export const firebaseLogin: AppThunk = (credentials: { email: string, password: string }) => {
  return async (dispatch: Dispatch): Promise<Action> => {
    dispatch(getStartPayloadOf(UserActions.LOGIN));
    try {
      const { email, password } = credentials;
      await firebase.auth().signInWithEmailAndPassword(email, password);
      fetchAppUser();
      return dispatch(getSuccessPayloadOf(UserActions.LOGIN));
    } catch (_e)  {
      console.log(_e);
      return dispatch(getFailurePayloadOf(UserActions.LOGIN));
    }
  }
}

export const firebaseLogout: AppThunk = () => {
  return async (dispatch: Dispatch): Promise<Action> => {
    dispatch(getStartPayloadOf(UserActions.LOGOUT));
    try {
      await firebase.auth().signOut()
      fetchAppUser();
      return dispatch(getSuccessPayloadOf(UserActions.LOGOUT));
    } catch (_e)  {
      console.log(_e);
      return dispatch(getFailurePayloadOf(UserActions.LOGOUT));
    }
  }
}

export const firebaseSignUp: AppThunk = (credentials: UserCredentials) => {
  return async (dispatch: Dispatch): Promise<Action> => {
    dispatch(getStartPayloadOf(UserActions.SIGN_UP));
    console.log('signing iup');
    try {
      const { success } = (await cloudFunction(CloudFunctions.FIREBASE_SIGN_UP)(credentials)).data;
      return dispatch(success ?
        getSuccessPayloadOf(UserActions.SIGN_UP)
        : getFailurePayloadOf(UserActions.SIGN_UP)
      );
    } catch (_error) {
      console.log(_error);
      return dispatch(getFailurePayloadOf(UserActions.SIGN_UP));
    }
  }
}


export const fetchAppUser: AppThunk = () => {
  return async (dispatch: Dispatch): Promise<Action> => {
    dispatch(getStartPayloadOf(UserActions.FETCH_USER));
    try {
      const user = (await cloudFunction(CloudFunctions.FETCH_APP_USER)()).data;
      return dispatch(getSuccessPayloadOf(UserActions.FETCH_USER, user));
    } catch (_e) {
      console.log(_e);
      return dispatch(getFailurePayloadOf(UserActions.FETCH_USER));
    }
  } 
}